import * as yup from 'yup';
import { memorizeMultipleArgs } from 'axp-fx-common';
import constraints from '../constants/validationConstraints';
import labels from '../constants/labels';
import * as ERROR_MSG from '../constants/validationMessages';

const validatePasswordWithFxAccountName = memorizeMultipleArgs(
  async (value, ctx) => {
    const { fxAccountName } = ctx.options.parent;

    if (value?.includes(fxAccountName)) {
      return ctx.createError({
        message: 'The password must not contain the FxAccount Name',
      });
    }

    return true;
  }
);

export const updatePasswordValidationschema = yup.object().shape({
  password: yup
    .string()
    .max(constraints.PASSWORD_MAX, ERROR_MSG.MAX_ERROR(labels.PASSWORD, constraints.PASSWORD_MAX))
    .min(constraints.PASSWORD_MIN, ERROR_MSG.MIN_ERROR(labels.PASSWORD, constraints.PASSWORD_MIN))
    .matches(constraints.PASSWORD_COMMON_REGEX, ERROR_MSG.PASSWORD_COMMON_REGEX_ERR)
    .matches(constraints.PASSWORD_REGEX, ERROR_MSG.PASSWORD_REGEX_ERR)
    .test(
      'Password should not contain FxAccount Name',
      '',
      validatePasswordWithFxAccountName
    )
    .required(ERROR_MSG.REQUIRED_ERROR(labels.PASSWORD)),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref('password')], ERROR_MSG.PASSWORD_NOT_MATCH_ERR)
    .required(ERROR_MSG.REQUIRED_ERROR(labels.CONFIRM_PASSWORD)),
});
